var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"container",staticClass:"row"},[_c('div',{class:_vm.listStyle},[_c('List',{attrs:{"__list":_vm.dataArray,"__isOnLoad":_vm.isListOnload,"isLightMode":_vm.isLightMode}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }